import { render, staticRenderFns } from "./CustomNav.vue?vue&type=template&id=6c37f3ee&scoped=true"
import script from "./CustomNav.vue?vue&type=script&lang=js"
export * from "./CustomNav.vue?vue&type=script&lang=js"
import style0 from "./CustomNav.vue?vue&type=style&index=0&id=6c37f3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37f3ee",
  null
  
)

export default component.exports